import { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'

// import Icon from '@/components/Icon'
import { MessageContainer, MessageItem } from './styles'

interface MessageProps {
  type: 'info' | 'error' | 'warning'
  content: string
  duration?: number
  onClose?: () => void
}

let messageContainer: HTMLDivElement | null = null
let root: any = null

const Message = ({ type, content, duration = 3000, onClose }: MessageProps) => {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false)
      setTimeout(() => {
        onClose?.()
      }, 300)
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onClose])

  // const getIcon = () => {
  //   switch (type) {
  //     case 'info':
  //       return <Icon type="info" />
  //     case 'error':
  //       return <Icon type="error" />
  //     case 'warning':
  //       return <Icon type="warning" />
  //   }
  // }

  return (
    <MessageItem $type={type} $visible={visible}>
      {content}
    </MessageItem>
  )
}

const createMessage = (type: MessageProps['type'], content: string, duration?: number) => {
  if (!messageContainer) {
    messageContainer = document.createElement('div')
    document.body.appendChild(messageContainer)
    root = createRoot(messageContainer)
  }

  const messages = (
    <MessageContainer>
      <Message
        type={type}
        content={content}
        duration={duration}
        onClose={() => {
          root.unmount()
          messageContainer?.remove()
          messageContainer = null
          root = null
        }}
      />
    </MessageContainer>
  )

  root.render(messages)
}

export default {
  info: (content: string, duration?: number) => createMessage('info', content, duration),
  error: (content: string, duration?: number) => createMessage('error', content, duration),
  warning: (content: string, duration?: number) => createMessage('warning', content, duration),
}
